<template>
    <app-layout>
      <template>
      </template> 
        <div>
          <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
            <div>
              <div>
                <span class="mx-2">Menu Manager</span>
                <button v-on:click="saveNewSequence" class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 m-2 rounded">
                  Save
                </button>
                <div class="mt-2">
                  <div
                    class="
                      bg-white
                      overflow-hidden                      
                      px-2
                      py-2
                      sm:rounded-lg
                    "
                  >
                      <div class="grid grid-cols-3">
                        <div>
                          <span class="mx-2">Menus</span>
                          <DxSortable
                            v-model:data="fieldList"
                            :element-attr="sortableAttributes"
                            :group="draggingGroupName"
                            :allow-reordering="true"
                            :allow-drop-inside-item="true"
                            data="fieldList"
                            @drag-start="onTabDragStart($event)"
                            @reorder="onTabDrop($event)"
                            @add="onTabDrop($event)"
                          >
                            <div
                              v-for="tas in fieldList"
                              :key="tas.dataField"
                              class="card dx-card dx-theme-text-color dx-theme-background-color m-2"
                            >
                              <div v-if="checkVal(tas)" class="card-subject p-2">
                                {{ tas.label }}
                              </div>
                              <div v-else class="card-subject p-2">{{ tas.label }}</div>
                            </div>
                          </DxSortable>
                        </div> 
                        <div class="col-span-2">
                          <span class="mx-2">Menu Groups</span>
                          <DxSortable
                              v-model:data="layoutDef"
                              item-orientation="vertical"
                              drag-direction="vertical"
                              group="kk"
                              :allow-reordering="true"
                              data="layoutDef"
                              @drag-start="onTabDragStart($event)"
                              @reorder="onTabDrop($event)"
                              @add="onTabDrop($event)"
                              :allow-drop-inside-item="true"
                            >
                              <!-- <div v-for="tas in tags2" :key="tas.name" class="card dx-card dx-theme-text-color dx-theme-background-color m-2">
                                            <div class="card-subject p-2">{{ tas.name }}</div>
                                    </div> -->
                              <div
                                v-for="task in layoutDef"
                                :key="task.name"
                                style="background: #86c285; margin: 5px"
                                class="p-2"
                              >
                                <div class="list-title dx-theme-text-color">{{ task.name }}</div>
                                <DxSortable
                                  v-model:data="task.items"
                                  data="task.items"
                                  :element-attr="sortableAttributes"
                                  :group="draggingGroupName"
                                  @drag-start="onTabDragStart($event)"
                                  @reorder="onTabDrop($event)"
                                  @add="onTabDrop($event)"
                                  :allow-reordering="true"
                                >
                                  <div
                                    v-for="tas in task.items"
                                    :key="tas"
                                    class="card dx-card dx-theme-text-color dx-theme-background-color m-2"
                                  >
                                    <div v-if="checkVal(tas)" class="card-subject p-2">
                                      {{ tas.label }}
                                    </div>
                                    <div v-else class="card-subject p-2">{{ tas.label }}</div>
                                  </div>
                                </DxSortable>
                              </div>
                            </DxSortable>
                        </div>
                      </div>   

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </app-layout>
       
    </template>
    <script>
      import AppLayout from '@/Layouts/AppLayout.vue';
      import DxSortable from "devextreme-vue/sortable";
      import {
        getFieldsList,
        getLayout,
        setLayout,
        setDeployLayout,
      } from "@/Pages/Builder/base.js";
    
      export default  {
          props: {
                moduleRoute:String,
                headers:Array,
                moduleName: String,
                slug:String,
                menus: {
                  type: Object,
                  default: () => ({}),
                },
                mgroup: {
                  type: Object,
                  default: () => ({}),
                }, 
              },
          components: {
            DxSortable,
            AppLayout
          },
          data() {
            return {
                grpName: "",
                draggingGroupName: "shared",
                sortableAttributes: {
                  class: "classjj",
                },
                fieldList: [
                {
                    editorType: "dxTextBox",
                    dataField: "name",
                    label:"Name",
                    helpText: ""
                },
                {
                    editorType: "dxTextBox",
                    dataField: "address",
                    label:"Address",
                    helpText: ""
                },
                ],
                layoutDef: [
                  {
                    name: "name",
                    itemType: "group", 
                    items:[
                      {
                        editorType: "dxTextBox",
                        dataField: "address",
                        label:{text:"Address"},
                        helpText: ""
                      },
                  ]
                  },
                  {
                    name: "name",
                    itemType: "group", 
                    items:[]
                  }
                ],

                items: [
                  {
                    dataField: "Address",
                    editorType: "dxDateBox",
                    editorOptions: {
                      type: "datetime",
                    },
                  },
                ],
                field_List: new Object(),
              };
          },
          methods:{
            checkVal(val) {
              if (val instanceof Object) {
                return true;
              }
              return false;
            },
            saveNewSequence()
            {
              this.$inertia.post('/'+this.slug+'/menu-management', {"group_data": this.layoutDef});
            },
            onTabDragStart(e) {
              e.itemData = e.fromData[e.fromIndex];
            },
            onListReorder(e) {
              const list = this.tags.splice(e.fromIndex, 1)[0];
              this.tags.splice(e.toIndex, 0, list);
            },
            onTabDrop(e) {
              e.fromData.splice(e.fromIndex, 1);
              e.toData.splice(e.toIndex, 0, e.itemData);
            },
          },
          mounted() {
              this.fieldList = this.menus;
              //this.layoutDef = this.mgroup;
              this.layoutDef = this.mgroup.map(obj => ({
                  ...obj,
                  items: obj.rlt_menugroup_menu,
                  rlt_menugroup_menu:undefined
                }));

                //console.log(this.layoutDef);
          }
      }
    </script>
    
    
    <style>
    .classjj {
      min-height: 20px;
      /* background: rgba(59, 130, 246, 0.5) */
      background: rgb(113, 181, 112);
      /* background: #17a2b8; */
    }
    </style>